import Konva from "konva";
import { cloneDeep } from "lodash";
import { useEffect, useRef, useState } from "react";
import { Star, Transformer } from "react-konva";

const TriangleNew = ({
  selectedObject,
  shapeProps,
  setSelectedObject,
  addToHistory,
  setObjectScreen,
  currentMultipleSelection,
  transformerSelectedObject
}) => {
  const [isSelected, setIsSelected] = useState(false);
  const shapeRef = useRef<Konva.Shape>();
  const trRef = useRef<Konva.Transformer>();

  useEffect(() => {
    if (shapeRef.current === selectedObject) {
      setIsSelected(true);
      transformerSelectedObject.current = trRef.current;
    } else {
      setIsSelected(false);
    }
  }, [selectedObject, isSelected]);

  useEffect(() => {
    trRef.current?.setNodes([shapeRef.current]);
    trRef.current?.setZIndex(trRef.current.getParent().children.length - 1);
    trRef.current?.getLayer().batchDraw();
  }, [isSelected]);

  return (
    <>
      <Star
        ref={shapeRef}
        name="triangleNew"
        {...shapeProps}
        innerRadius={20}
        shadowBlur={1}
        shadowColor={shapeProps.fill}
        outerRadius={40}
        numPoints={3}
        onClick={(event: Konva.KonvaEventObject<MouseEvent>) => {
          const isTargetInsideMultipleSelection =
            currentMultipleSelection.current?.nodes().includes(event.target);

          if (isTargetInsideMultipleSelection) {
            setSelectedObject(null);
          } else {
            setSelectedObject(event.target);
            currentMultipleSelection.current?.setNodes([]);
          }
        }}
        onDragStart={(event: Konva.KonvaEventObject<MouseEvent>) => {
          if (
            currentMultipleSelection.current?.nodes().length === 0 ||
            !currentMultipleSelection.current
          ) {
            addToHistory();
          }

          //if mutipleSelection includes element being dragged
          if (
            currentMultipleSelection.current?.nodes().includes(event.target)
          ) {
            setSelectedObject(null);
          } else {
            setSelectedObject(event.target);
            currentMultipleSelection.current?.setNodes([]);
          }
        }}
        onDragEnd={(event: Konva.KonvaEventObject<MouseEvent>) => {
          setObjectScreen(prevState => {
            let cloneState = cloneDeep(prevState);

            cloneState.forEach(page => {
              page.renderObjects.forEach(object => {
                if (object.id === event.target.id()) {
                  object.x = event.target.absolutePosition().x;
                  object.y = event.target.absolutePosition().y;
                }
              });
            });

            return cloneState;
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          onClick={event => {}}
          onTransformStart={(event: Konva.KonvaEventObject<MouseEvent>) => {
            if (
              currentMultipleSelection.current?.nodes().length === 0 ||
              !currentMultipleSelection.current
            ) {
              addToHistory();
            }
          }}
          onTransformEnd={(event: Konva.KonvaEventObject<MouseEvent>) => {
            let myWidth = trRef?.current?.width();
            let myHeight = trRef?.current?.height();
            let rotation = trRef?.current.rotation();

            if (myWidth && myHeight) {
              setObjectScreen(prevState => {
                let cloneState = cloneDeep(prevState);
                cloneState.forEach(page => {
                  page.renderObjects.forEach(object => {
                    if (object.id === event.target.id()) {
                      object.x = event.target.absolutePosition().x;
                      object.y = event.target.absolutePosition().y;
                      object.rotation = rotation;
                      object.scaleX = event.target.scaleX();
                      object.scaleY = event.target.scaleY();
                    }
                  });
                });
                return cloneState;
              });
            }
          }}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </>
  );
};

export default TriangleNew;
